"use strict";

const MuniLiftStationsFilters = function () {
  const searchDbFields = ["name", "address"];
  const searchFields = ["name", "address"];

  var filterResourceDataHandler = async function (
    unfilteredData,
    filters,
    loadingScreen,
    smartFilters,
  ) {
    if (onlineFilterIsSet(filters)) {
      try {
        return await ResourceFilters.filterOnline(
          unfilteredData,
          loadingScreen,
          MuniLiftStationsGeoServerLayer.getLayerData,
        );
      } catch (e) {
        ApiError.assertIs(e);
      }
    }

    return filterOffline(unfilteredData, filters, smartFilters);
  };

  var filterOffline = function (unfilteredData, filters, smartFilters) {
    return smartFilters ? smartFilters.filter(unfilteredData, filters) : unfilteredData;
  };

  var onlineFilterIsSet = function (filters) {
    if (filters.toDoFilters) {
      return ResourceFilters.toDoSpatialFiltersAreSet(filters.toDoFilters);
    } else {
      return ResourceFilters.spatialFiltersAreSet(filters) || isOnlineDateFilterSet(filters);
    }
  };

  var addGeoServerViewParams = function (params, filters) {
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("correctiveAction")) {
      params["correctiveAction"] = filters.correctiveAction.map((item) => `'${item}'`).join("\\,");
    }
    if (
      !SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("correctiveAction") &&
      $('input[name="correctiveAction"][value="no-action"]').is(":checked")
    ) {
      params[`includeNoAction`] = true;
    }
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("enforcementLevel")) {
      params["enforcementLevel"] = filters.enforcementLevel.map((item) => `'${item}'`).join("\\,");
    }
    if (
      !SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("enforcementLevel") &&
      $('input[name="enforcementLevel"][value="null"]').is(":checked")
    ) {
      params[`includeNoActionLevel`] = true;
    }
    ResourceFilters.addDateParam(
      params,
      "routine",
      filters.routineDate?.from,
      filters.routineDate?.to,
    );
    ResourceFilters.addDateParam(
      params,
      "repair",
      filters.repairDate?.from,
      filters.repairDate?.to,
    );
  };

  var isOnlineDateFilterSet = function (filters) {
    return isOnlineDateType(filters.dateType) && (filters.dateFrom || filters.dateTo);
  };

  var isOnlineDateType = function (dateType) {
    return ["routine", "repair", "clean"].includes(dateType);
  };

  var addGeoServerFilterQuery = function (queryStrings, filters) {
    if (filters.searchString) {
      queryStrings.push(
        GeoServerFilterFunctions.getSearchQuery(searchDbFields, filters.searchString),
      );
    }
    GeoServerFilterFunctions.addGeographicalFocusFiltersToQuery(filters, queryStrings);

    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "implementerType",
      "implementer_type",
    );
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "maintainedBy",
      "responsible_party_maintenance",
    );
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "landOwnership",
      "property",
    );
    GeoServerFilterFunctions.addFilterToGeoServerQuery(queryStrings, filters, "type", "type");
    GeoServerFilterFunctions.addFilterToGeoServerQuery(queryStrings, filters, "phase", "phase");
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "consequenceOfFailure",
      "cof_final_text",
    );
    GeoServerFilterFunctions.addMuniConditionFilterToGeoServerQuery(queryStrings, filters);
    if (filters.installDate) {
      GeoServerFilterFunctions.addDateQuery(
        queryStrings,
        "install_date",
        filters.installDate?.from,
        filters.installDate?.to,
      );
    }
  };

  var getFilterConfigs = function () {
    return {
      implementerType: "implementerType",
      maintainedBy: "maintainedBy",
      landOwnership: "landOwnership",
      condition: "condition",
      phase: "phase",
      consequenceOfFailure: "cof",
      drainsToRw: "drains_to_rw",
      drainsToC: "drains_to_c",
      catchmentName: "catchment_name",
      zones: "zone_names",
      correctiveAction: ["correctiveAction", "array"],
      enforcementLevel: ["enforcementLevel", "array"],
      type: "type",
      subGroups: "groupId",
      routineDate: (datum, filters) =>
        ResourceFilters.passDatesFilter(
          datum.routine,
          filters.routineDate?.from,
          filters.routineDate?.to,
        ),
      repairDate: (datum, filters) =>
        ResourceFilters.passDatesFilter(
          datum.repair,
          filters.repairDate?.from,
          filters.repairDate?.to,
        ),
      otherFilters: (datum, filters) => {
        return (
          ResourceFilters.passSearchStringFilter(datum, filters, searchFields) &&
          ResourceFilters.passIsoDateFilter(
            datum.installDate,
            filters.installDate?.from,
            filters.installDate?.to,
          )
        );
      },
    };
  };

  return {
    filterResourceDataHandler,
    isOnlineDateFilterSet,
    addGeoServerFilterQuery,
    addGeoServerViewParams,
    getFilterConfigs,
  };
};

module.exports = MuniLiftStationsFilters();

const ApiError = require("../errors/apiError");
const ResourceFilters = require("../filters/resourceFilters");
const MuniLiftStationsGeoServerLayer = require("./muniLiftStationsGeoServerLayer");
const GeoServerFilterFunctions = require("../mapFunctions/geoServerFilterFunctions");
const SmartFilterRegistry = require("../filters/smartFilterRegistry");
